export const NATIONAL_PROMOTION_AVAILABLE = 'NATIONAL_PROMOTION_AVAILABLE'
